import { default as Analytics } from './ContentAnalytics/ContentAnalytics.container';
import { default as AssetPackBuilder } from './ContentAssetPackBuilder/ContentAssetPackBuilder.container';
import { default as Fusion } from './ContentFusion/ContentFusion.container';
import { default as Goldens } from './ContentGoldens/ContentGoldens.container';
import { default as Guassian } from './ContentGuassian/ContentGuassian.container';
import { default as HeroGenerator } from './ContentHeroGenerator/ContentHeroGenerator.container';
import { default as ImageTo3d } from './ContentImageTo3d/ContentImageTo3d.container';
import { default as Invitation } from './ContentInvitation/ContentInvitation.container';
import { default as MaterialStudio } from './ContentMaterialStudio/ContentMaterialStudio.container';
import { default as Quality } from './ContentQuality/ContentQuality.container';
import { default as Realtime } from './ContentRealtime/ContentRealtime.container';
import { default as StyleTransfer } from './ContentStyleTransfer/ContentStyleTransfer.container';
import { default as TextTo3d } from './ContentTextTo3d/ContentTextTo3d.container';
import { default as TextToInstance } from './ContentTextToInstance/ContentTextToInstance.container';
import { default as Three } from './ContentThree/ContentThree.container';

export const content = {
  Analytics,
  AssetPackBuilder,
  Fusion,
  Guassian,
  HeroGenerator,
  ImageTo3d,
  MaterialStudio,
  StyleTransfer,
  TextToInstance,
  Three,
  Realtime,
  TextTo3d,
  Invitation,
  Goldens,
  Quality,
};
